export const ChinaEcharts = (data)=>{
    return {
        title: {
            text: '中国裂纹识别统计（2024年）',
            subtext: '数据来自本系统',
            left: 'center'
        },
        tooltip: {
            trigger: 'item',
            showDelay: 0,
            transitionDuration: 0.2
        },
        visualMap: {
            left: 'right',
            min: 0,
            max: 16,
            inRange: {
                color: [
                    '#313695',
                    '#4575b4',
                    '#74add1',
                    '#abd9e9',
                    '#e0f3f8',
                    '#ffffbf',
                    '#fee090',
                    '#fdae61',
                    '#f46d43',
                    '#d73027',
                    '#a50026'
                ]
            },
            text: ['High', 'Low'],
            calculable: true,
            bottom:'center'
        },
        toolbox: {
            show: true,
            //orient: 'vertical',
            left: 'left',
            top: 'top',
            feature: {
                dataView: { readOnly: false },
                restore: {},
                saveAsImage: {}
            }
        },
        series: [
            {
                name: 'CHINA',
                type: 'map',
                roam: true,
                map: 'CHINA',
                emphasis: {
                    label: {
                        show: true
                    }
                },
                data: data
            }
        ]
    };
}
